module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-upgrade-subscription-notice/user-upgrade-subscription-notice.component.scss
// module id = ./src/app/admin/user-upgrade-subscription-notice/user-upgrade-subscription-notice.component.scss
// module chunks = main